// Apply a TenantBranding to the document's CSS custom properties.
// The prototype CSS uses --brand / --brand-tint / --brand-tint-2 for any
// brand-colored chrome; updating those vars retheme the entire app live.

import type { TenantBranding } from "./types";

function hexToRgba(hex: string, alpha: number): string {
  const m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!m) return `rgba(0,0,0,${alpha})`;
  const r = parseInt(m[1], 16);
  const g = parseInt(m[2], 16);
  const b = parseInt(m[3], 16);
  return `rgba(${r},${g},${b},${alpha})`;
}

export function applyBranding(branding: TenantBranding): void {
  const root = document.documentElement.style;
  root.setProperty("--brand", branding.primary_color);
  root.setProperty("--brand-tint", hexToRgba(branding.primary_color, 0.06));
  root.setProperty("--brand-tint-2", hexToRgba(branding.primary_color, 0.14));
  document.title = branding.application_name;
}
